import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { ShopApiService } from 'features/shop-item/api/shop-api.service';

import { shopCatQueryKeys } from './query-keys'; ;




const { getCategory } = ShopApiService();

const getEventImageQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: shopCatQueryKeys.list(params),
    queryFn: ({ signal }) => getCategory(params, { config: { signal } }),
    ...options,
});

export const useGetCategory = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getEventImageQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};



